import { render, staticRenderFns } from "./DebtInstallmentBillTable.vue?vue&type=template&id=65b5001c&scoped=true"
import script from "./DebtInstallmentBillTable.vue?vue&type=script&lang=js"
export * from "./DebtInstallmentBillTable.vue?vue&type=script&lang=js"
import style0 from "./DebtInstallmentBillTable.vue?vue&type=style&index=0&id=65b5001c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5001c",
  null
  
)

export default component.exports